export const features = [
  {
    icon: "/dashboard/call-to-action/shield.svg",
    label: "Bank-Level Encryption",
  },
  {
    icon: "/dashboard/call-to-action/check.svg",
    label: "SSL secured transactions",
  },
  {
    icon: "/dashboard/call-to-action/lock.svg",
    label: "Your information stays private",
  },
];
